/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.donations.config.controllers', [
  'ui.router'
])

.controller('DonationsConfigController', ['$scope', '$state', function($scope, $state) {

    $scope.donationsConfig = {

      model: "",

      currentType: '',
      type: [
        'campaigns',
        'appeals',
        'funds'
      ],

      init: function() {
        if ($state.current.name === 'application.donations.config.settings') {
          this.currentType = 'settings';
        } else {
          this.currentType = $state.params.type || this.type[0];
        }
      },

      isTabActive: function (value) {
        return (value === this.currentType);
      },

      getState: function(value) {
        this.currentType = value;
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.donationsConfig.init();

}]);